
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-tips",
      function () {
        return require("private-next-pages/travel-tips.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel-tips"])
      });
    }
  